export function flattenTreeItems(treeItems, expandedItemIds, level = 0) {
    const flatTreeItems = [];
    for (const item of treeItems) {
        const flatTreeItem = {
            item,
            level,
        };
        flatTreeItems.push(flatTreeItem);
        if (item.children && expandedItemIds.includes(item.id)) {
            flatTreeItems.push(...flattenTreeItems(item.children, expandedItemIds, level + 1));
        }
    }
    return flatTreeItems;
}
